import { useEffect, useState } from 'react';

import { timeBetween } from '@vimeo/core/libs/date/date';
import { interactionToolsConfig } from '@vimeo/live-core/configs/InteractionToolsConfig';
import { registerInterval, unRegisterInterval } from '@vimeo/live-core/utils/general/timers';

export function useQuestionTimeAsked(createdAt: number): string {
  const [timeAsked, setTimeAsked] = useState(() => timeBetween(new Date(createdAt), new Date()));

  useEffect(() => {
    setTimeAsked(timeBetween(new Date(createdAt), new Date()));

    const intervalId: number = registerInterval(
      () => {
        setTimeAsked(timeBetween(new Date(createdAt), new Date()));
      },
      interactionToolsConfig.QNA.QNA_POSTED_AT_REFRESH_PERIOD,
      'questionItem',
    );

    return () => unRegisterInterval(intervalId);
  }, [createdAt]);

  return timeAsked;
}
